<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>
<label>Nome</label>
<input
  type="text"
  [formControl]="value"
  class="field mt-3 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" />
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      [label]="button_ok_title"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
